import {
  DimeBreadcrumb,
  DimeBreadcrumbItem,
  DimeBreadcrumbLink,
  DimeBreadcrumbList,
  DimeBreadcrumbPage,
  DimeBreadcrumbSeparator,
} from '@nudool/design-system';
import { Link, useRouter, useRouterState } from '@tanstack/react-router';
import { Fragment } from 'react';

import { useBreadcrumbLabels } from './BreadcrumbLabelsContext.js';
import { buildAppBreadcrumbs } from './build-app-breadcrumbs.js';

export function AppBreadcrumbs() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { labelsById } = useBreadcrumbLabels();
  // Read from the router rather than a hand-kept list, so a new route cannot drift out of it.
  const router = useRouter();
  const routablePaths = new Set(Object.keys(router.routesByPath ?? {}));
  const crumbs = buildAppBreadcrumbs(pathname, labelsById, routablePaths);

  if (crumbs.length === 0) return null;

  return (
    <DimeBreadcrumb className="min-w-0">
      <DimeBreadcrumbList className="min-w-0 flex-nowrap">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <Fragment key={`${crumb.label}-${index}`}>
              {index > 0 ? <DimeBreadcrumbSeparator /> : null}
              <DimeBreadcrumbItem className="min-w-0">
                {crumb.to && !isLast ? (
                  <DimeBreadcrumbLink asChild>
                    <Link to={crumb.to} className="truncate no-underline">
                      {crumb.label}
                    </Link>
                  </DimeBreadcrumbLink>
                ) : isLast ? (
                  <DimeBreadcrumbPage className="truncate font-medium">
                    {crumb.label}
                  </DimeBreadcrumbPage>
                ) : (
                  <span className="truncate">{crumb.label}</span>
                )}
              </DimeBreadcrumbItem>
            </Fragment>
          );
        })}
      </DimeBreadcrumbList>
    </DimeBreadcrumb>
  );
}
